
import Vue from 'vue';
import StackLayers from '@/components/base/StackLayers.vue';
import { DISCORD_INVITE_LINK } from '@/utils';
import { mapActions, mapState } from 'vuex';
import ListItem from '@/components/base/ListItem.vue';
import { functions } from '@/firebase';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { analytics, EVENTS } from '@/services/analytics';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import {
	openSupportChat,
	getSupportChatErrorMessage,
	buildSupportMailtoHref,
	SUPPORT_CHAT_SOURCE,
	SupportChatFailure,
	SupportChatIdTokenResponse,
} from '@/utils/supportChat';

export default Vue.extend({
	name: 'GetSupportDialog',
	props: {
		value: { type: Boolean, default: false },
	},
	data () {
		return {
			isOpeningChatSupportWidget: false,
			chatSupportFailureReason: null as SupportChatFailure,
		};
	},
	computed: {
		...mapState([
			'user',
			'team',
			'isAdminProxyingUser',
		]),
		chatSupportErrorMessage (): string {
			return this.chatSupportFailureReason
				? getSupportChatErrorMessage(this.chatSupportFailureReason)
				: '';
		},
		chatSupportMailtoHref (): string {
			return buildSupportMailtoHref(this.chatSupportFailureReason, this._get(this.user, 'email', null));
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		onInput (val: boolean) {
			// Fire only on open transition (val=true). Strong "stuck/frustrated" signal.
			if (val && !this.value) {
				analytics.track(EVENTS.SUPPORT_DIALOG_OPENED, {
					source_route: this._get(this.$route, 'name', null),
				});
			}
			this.$emit('input', !!val);
		},
		openLearnSite () {
			window.open('https://learn.rundiffusion.com', '_blank').focus();
		},
		onJoinDiscordServer () {
			window.open(DISCORD_INVITE_LINK, '_blank').focus();
		},
		async onStartChatSupport () {
			this.chatSupportFailureReason = null;
			this.isOpeningChatSupportWidget = true;

			const result = await openSupportChat({
				source: SUPPORT_CHAT_SOURCE.TOOLBAR_DIALOG,
				email: this._get(this.user, 'email', null),
				teamId: this.team ? this.team.id : null,
				isAdminProxyingUser: this.isAdminProxyingUser,
				createIdToken: async (teamId: string): Promise<SupportChatIdTokenResponse> => (
					(await functions.httpsCallable('getSupportChatIdToken')({ teamId })).data
				),
			});

			this.isOpeningChatSupportWidget = false;
			if (result.ok) return;

			// The alert stays until the next attempt. A snackbar that expires is
			// how the email fallback went unread through 14 retries.
			this.chatSupportFailureReason = result.reason;
			this.updateSnackbar({
				status: SNACKBAR_STATUS.ERROR,
				message: getSupportChatErrorMessage(result.reason),
				show: true,
				timeout: 20000,
			});
		},
	},
	components: {
		ListItem,
		StackLayers,
		DialogOrBottomSheet,
	},
});
